import { Table, Tag as AntTag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useMemo } from 'react';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Title } from '@atom/typography/typography';
import { useRequestLogs } from '@component/tables/application-logs/use-application-logs.hook';
import { RouteEnum } from '@enum/route.enum';
import { useMedia } from '@hook/style/use-media.hook';
import { RequestInnerRequestInterface, RequestInnerResponseInterface } from '@interface/logs/logs.interface';

import { DashboardLogCard, FooterWrapper } from './dashboard-log.style';

const columns = (isMobile: boolean) =>
  [
    {
      title: 'Time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      width: isMobile ? 142 : 164,
      render: (date: string) => dayjs(date).format(isMobile ? 'DD/MM/YY HH:mm' : 'DD/MM/YYYY HH:mm'),
    },
    {
      title: 'URL',
      dataIndex: 'request',
      key: 'request',
      ellipsis: true,
      render: (data: RequestInnerRequestInterface) => data.url,
    },
    {
      dataIndex: 'response',
      key: 'id',
      width: 72,
      render: (value: { status: number }) => (
        <AntTag color={value.status >= 400 ? 'error' : 'success'}>{value.status}</AntTag>
      ),
    },
    {
      title: 'Method',
      dataIndex: 'request',
      key: 'request',
      width: 100,
      render: (data: any) => <div style={{ textAlign: 'center' }}>{data?.method.toUpperCase()}</div>,
    },
    !isMobile && {
      title: 'Latency',
      dataIndex: 'response',
      key: 'response',
      width: 140,
      render: (data: RequestInnerResponseInterface) => `${data?.latencyMs.toFixed(2) ?? 0}ms`,
    },
  ].filter(Boolean) as ColumnsType<any>;

export const DashboardLog = () => {
  const { data } = useRequestLogs(5);
  const { isMobile } = useMedia();

  const tableColumns = useMemo(() => columns(isMobile), [isMobile]);

  return (
    <DashboardLogCard
      bordered={false}
      title={
        <Title level={isMobile ? 5 : 4} weight={500}>
          Api logs
        </Title>
      }
    >
      <Table columns={tableColumns} dataSource={data} pagination={false} showHeader={false} />
      <FooterWrapper>
        <Button href={RouteEnum.Logs.path} size='small' type={ButtonTypeEnum.Primary} ghost>
          VIEW ALL
        </Button>
      </FooterWrapper>
    </DashboardLogCard>
  );
};
